export default {
  title: 'Visão Geral da Empresa',
  description: 'Bem-vindo de volta, {{name}}! Isto é o que está a acontecer com o seu marketing.',
};
